module.exports = {"namespace":"merchant.products","id":"modules-merchant-products","production":{"baseUrl":"http://localhost:8089"},"homologation":{"baseUrl":"http://localhost:8089"},"development":{"baseUrl":"http://localhost:8089"}}


//////////////////
// WEBPACK FOOTER
// ./src/Module.json
// module id = 198
// module chunks = 0